<div class="nim__content-area">
  <div id="devPrintModal" class="modal is-touch is-short" [ngClass]="{'is-open': (isModalOpen | async)}">
    <div class="modal__content">
      <div class="modal__header">
        <h2 class="h2">Enter Admin Notes</h2>
      </div>
      <div class="modal__body pt0 pr0 flex">
        <div class="container col-12">
          <div class="row no-edge-gutters">
            <div class="col-11">
              <div class="form-group__icon-container">
                <input ncFocus #notesInput type="text" class="form-control" id="notesInput" [(ngModel)]="adminNotes"
                (keyup.enter)="onConfirm()">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal__footer flex justify-content-between">
        <button id="btnCloseDevPrintModal" (click)="onCancelClick()" class="btn btn--true-blue-inverse">Cancel</button>
        <button id="btnDevPrintConfirm" (click)="onConfirm()" [disabled]="!adminNotes" class="btn btn--true-blue">Print</button>
      </div>
    </div>
  </div>
